module.exports = __webpack_public_path__ + "static/popper-logo-outlined-fb38d0b34a253d52fc74cd9c4f3dcec3.svg";